import { render, staticRenderFns } from "./ActivationWiki.vue?vue&type=template&id=657be550&scoped=true&"
import script from "./ActivationWiki.vue?vue&type=script&lang=ts&"
export * from "./ActivationWiki.vue?vue&type=script&lang=ts&"
import style0 from "./ActivationWiki.vue?vue&type=style&index=0&id=657be550&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657be550",
  null
  
)

export default component.exports